// Polyfill for Array.prototype.at
if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    const len = this.length;
    if (index < 0) index += len;
    return this[index];
  };
}

// Polyfill for String.prototype.at
if (!String.prototype.at) {
  String.prototype.at = function (index) {
    const len = this.length;
    if (index < 0) index += len;
    return this.charAt(index);
  };
}
